import { cx } from '@linaria/core';
import { CopyLinkButton } from '@ui/kit';
import { headingCls } from './_share-drawer.style.js';
import { wrapperCls, copyWrapperCls, copyLabelCls, separatorCls } from './copy-section.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CopySection(props) {
  const href = `${process.env["COURSES_URL"]}/viser/${props.course.id}`;
  return /*#__PURE__*/jsxs("div", {
    className: wrapperCls,
    children: [/*#__PURE__*/jsxs("label", {
      className: copyWrapperCls,
      children: [/*#__PURE__*/jsx("div", {
        className: cx(headingCls, copyLabelCls),
        children: "Kopier link"
      }), /*#__PURE__*/jsx(CopyLinkButton, {
        href: href
      })]
    }), /*#__PURE__*/jsx("hr", {
      className: separatorCls
    })]
  });
}

export { CopySection };
//# sourceMappingURL=copy-section.js.map
